import TableFilter from '../table-models/TableFilter';

export const defaultAlignmentFilters: TableFilter[] = [
    { field: 'targetName', label: 'Name', value: '' },
    { field: 'targetDescription', label: 'Description', value: '' },
    { field: 'targetFramework', label: 'Framework', value: '' }
];
